import React, { Fragment, useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom';
import { decryptUrlDatapattern, encryptUrlDatapattern } from '../../../../../components/commonClass/EncFunc';
import SetPriceAlert from '../../../../../customControl/SetPriceAlert';

const HotelFilter = ({ 
    filterList,
    setHotelList,
    hotelCopyList
}: any) => {
    const location = useLocation();
    const [showSideFilter, setShowSideFilter] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const [showModal, setShowModal] = useState(false);
    const [unsubscribeSuccessfully, setUnsubscribeSuccessfully] = useState(false);

    const [seeMoreAmenities, setSeeMoreAmenities] = useState(5)

    const [filterValue, setFilterValue] = useState<any>({
        SearchField: "",
        UserRating: [],
        Amenities: [],
        PriceFilter: 0
    })

    const [minMaxPrice, setMinMaxPrice] = useState({
        maxPrice: 0,
        minPrice: 0
    })
    const max = localStorage.getItem('htlmax') ? decryptUrlDatapattern(localStorage.getItem('htlmax')) : 0;
    const min = localStorage.getItem('htlmin') ? decryptUrlDatapattern(localStorage.getItem('htlmin')) : 0;

    useEffect(() => {

        if (hotelCopyList?.length > 0) {
            if (min === 0 && max === 0) {
                let maxPrice = Math.max(...hotelCopyList?.map((list: any) => list?.lowestPriceWithMarkup)) || 0;
                let minPrice = Math.min(...hotelCopyList?.map((list: any) => list?.lowestPriceWithMarkup)) || 0;

                setMinMaxPrice((prev) => ({
                    ...prev,
                    maxPrice: Math.ceil(maxPrice),
                    minPrice: Math.floor(minPrice)
                }))

                localStorage.setItem('htlmax', encryptUrlDatapattern(Math.ceil(maxPrice)));
                localStorage.setItem('htlmin', encryptUrlDatapattern(Math.floor(minPrice)));
            }
            else {
                setMinMaxPrice((prev) => ({
                    ...prev,
                    maxPrice: max,
                    minPrice: min
                }))
            }

        }
    }, [hotelCopyList])

    const toggleSideFilter = () => {
        setShowSideFilter((prev) => !prev);
    }

    useEffect(() => {
        const staticFilters = Object.fromEntries(searchParams?.entries());
        setFilterValue((prev: any) => ({
            ...prev,
            SearchField: staticFilters?.SearchField ? staticFilters?.SearchField : "",
            UserRating: staticFilters?.UserRating ? decryptUrlDatapattern(staticFilters?.UserRating) : [],
            Amenities: staticFilters?.Amenities ? staticFilters?.Amenities?.split(',') : [],
            PriceFilter: staticFilters?.PriceFilter && Number(staticFilters?.PriceFilter) <= max ? Number(staticFilters?.PriceFilter) : max,
        }))

    }, [searchParams, max])

    //#region NEW code - get filter values for searching/filtering
    useEffect(() => {
        if (filterValue?.Amenities?.length <= 0 && filterValue?.UserRating?.length <= 0 && filterValue?.SearchField?.trim()?.length <= 0 && filterValue?.PriceFilter <= 0) {
            setHotelList(hotelCopyList?.length > 0 ? hotelCopyList : [])
        }
        else {
            const searchHotelAndCityCheckData = filterValue?.SearchField?.trim()?.length > 0 ?
                hotelCopyList?.filter((hotel: any) => {
                    const details = hotel?.hotelDetails?.[0];
                    const name = details?.hotelName?.toLowerCase();
                    const city = details?.cityName?.toLowerCase();
                    const searchTerm = filterValue?.SearchField?.toLowerCase()?.trim();

                    return name?.includes(searchTerm) || city?.includes(searchTerm);
                }) : hotelCopyList;

            const RatingCheckData = filterValue?.UserRating?.length > 0 ? searchHotelAndCityCheckData?.filter((hotel: any) => {
                const details = hotel?.hotelDetails?.[0];
                const RatingCheck = filterValue?.UserRating?.includes(details?.hotelRating);

                return RatingCheck;
            }) : searchHotelAndCityCheckData;

            const AmenitiesCheckData = filterValue?.Amenities?.length > 0 ? RatingCheckData?.filter((hotel: any) => {
                const details = hotel?.hotelDetails?.[0];
                const AmenitiesCheck = filterValue?.Amenities?.some((someAmenity: any) => details?.hotelFacilities?.includes(someAmenity));

                return AmenitiesCheck;
            }) : RatingCheckData;

            const PriceCheckData = filterValue?.PriceFilter > 0 ? AmenitiesCheckData?.filter((hotel: any) => {
                const PriceCheck = hotel?.lowestPriceWithMarkup <= filterValue?.PriceFilter;

                return PriceCheck;
            }) : AmenitiesCheckData

            const hotelFilterData = PriceCheckData

            setHotelList(hotelFilterData?.length > 0 ? hotelFilterData : null)
        }
    }, [filterValue, hotelCopyList])

    const handleOnChange = (name: any, value: any, checked: any, type: any) => {
        let objFilter: any = { ...filterValue }
        if (type === "text") {
            objFilter = {
                ...objFilter,
                [name]: value
            }
            setFilterValue((prev: any) => ({ ...prev, [name]: value }));
        }
        else if (type === "range") {
            objFilter = {
                ...objFilter,
                [name]: Number(value)
            }
            setFilterValue((prev: any) => ({ ...prev, [name]: Number(value) }));
        }
        else {
            if (checked) {
                objFilter = {
                    ...objFilter,
                    [name]: [...objFilter?.[name], value]
                }
                setFilterValue((prev: any) => ({ ...prev, [name]: [...prev?.[name], value] }));
            } else {
                objFilter = {
                    ...objFilter,
                    [name]: [...objFilter?.[name]?.filter((data: any) => data !== value)]
                }
                setFilterValue((prev: any) => ({ ...prev, [name]: [...prev?.[name]?.filter((data: any) => data !== value)] }));
            }
        }
        createSearchUrl(name, name === "UserRating" ? encryptUrlDatapattern(objFilter?.[name]) : objFilter?.[name])
    }
    //#endregion

    const createSearchUrl = (key: any, value: any) => {
        const urlParams = new URLSearchParams(searchParams);

        urlParams.set(key, value)

        setSearchParams(urlParams)
    }

    //#endregion

    const OnClickSeeMoreAndLess = (count: any) => {
        setSeeMoreAmenities(count)
    }

    useEffect(() => {
        if (location?.search === '?GuestNationality=IN&roomReq1=1&roomReq1noOfAdult=1&roomReq1noOfChildren=0&isExplore=false') {
            localStorage.setItem('htlmax', encryptUrlDatapattern(0));
            localStorage.setItem('htlmin', encryptUrlDatapattern(0));
        }

    }, [location])
    return (
        <>
            <span className="openSideFilter" onClick={toggleSideFilter}>
                <i className="fa-solid fa-filter"></i> Filter
            </span>

             <div id="sideFilter" className={showSideFilter ? "sideFilter showFilter" : "sideFilter"}>
                <div className="filterDiv" style={{ position: (showModal || unsubscribeSuccessfully) ? 'relative' : 'sticky' }}>
                    <i className="closeSideFilter fa-solid fa-xmark .cursor_pointer" onClick={toggleSideFilter}></i>

                    <SetPriceAlert showModal={showModal} setShowModal={setShowModal} setUnsubscribeSuccessfully={setUnsubscribeSuccessfully} unsubscribeSuccessfully={unsubscribeSuccessfully} />

                    {/* <div className="appliedFilter">
                        <h4>Applied Filters</h4>

                        <button>Breakfast Included <span className="removeValue">x</span></button>
                    </div> */}

                    <div className="searchByLocation">
                        <h4>Search for locality / hotel name</h4>
                        <div className="pr">
                            <input
                                type="text"
                                className="form-control form-input"
                                placeholder="Search for locality / hotel name"
                                value={filterValue?.SearchField}
                                // onKeyDown={handleKeyDown}
                                // onChange={(e) => {
                                //     if (e.target.value) {
                                //         setSearchField(e.target.value)
                                //     } else {
                                //         setHotelList(hotelCopyList)
                                //         setSearchField(e.target.value)
                                //     }
                                // }}
                                onChange={(e) => handleOnChange('SearchField', e.target.value, null, "text")}
                            />
                            <button className="search-icon cursor_pointer px-2"
                            // onClick={() => onSearchIconClick()}
                            ><i className="fas fa-search"></i>
                            </button>
                        </div>
                    </div>

                    <div className="accordion" id="accordionPanelsStayOpenExample">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="leftFilter3">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false"
                                    aria-controls="panelsStayOpen-collapseThree">
                                    User Ratings
                                </button>
                            </h2>
                            <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse show"
                                aria-labelledby="leftFilter3">
                                <div className="accordion-body">
                                    <ul>
                                        {filterList?.userRatingTitle?.length > 0 && filterList?.userRatingTitle?.map((rate:any) => (
                                            <li key={rate?.Id}>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input" type="checkbox"
                                                        value={rate?.Id}
                                                        // checked={hotelFilter?.UserRating?.includes(rate?.Id) ? true : false}
                                                        checked={filterValue?.UserRating?.includes(rate?.Id) ? true : false}
                                                        id={rate?.RatingName}
                                                        name='UserRating'
                                                        onChange={(e) => handleOnChange('UserRating', rate?.Id, e.target.checked, "checkbox")}
                                                    />
                                                    <label className="form-check-label" htmlFor={rate?.RatingName}>
                                                        {rate?.RatingName} {rate?.Id}+ {filterList?.userRatings?.length > 0 &&
                                                            (<span>({filterList?.userRatings?.find((rateCount:any) => rateCount?.id === rate?.Id)?.count || 0})</span>
                                                            )}
                                                    </label>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="leftFilter11">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#panelsStayOpen-collapseEleven" aria-expanded="false"
                                    aria-controls="panelsStayOpen-collapseEleven">
                                    Search By Hotel Amenities
                                </button>
                            </h2>
                            <div id="panelsStayOpen-collapseEleven" className="accordion-collapse collapse show  hotel_amenities"
                                aria-labelledby="leftFilter11 ">
                                <div className="accordion-body">
                                    <ul>
                                        {filterList?.hotelFacilities?.length > 0
                                            ? <Fragment>
                                                {filterList?.hotelFacilities?.slice(0, seeMoreAmenities).map((amenity:any) => (
                                                    <li key={amenity}>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                value={amenity}
                                                                // checked={hotelFilter?.Amenities?.includes(amenity) ? true : false}
                                                                checked={filterValue?.Amenities?.includes(amenity) ? true : false}
                                                                id={amenity}
                                                                name='Amenities'
                                                                onChange={(e) => handleOnChange('Amenities', amenity, e.target.checked, "checkbox")}
                                                            />
                                                            <label className="form-check-label" htmlFor={amenity}>{amenity} {/* <span>(25)</span> */} </label>
                                                        </div>
                                                    </li>
                                                ))}

                                                {
                                                    filterList?.hotelFacilities?.length > 5 ?
                                                        seeMoreAmenities <= 5 ?
                                                            <li className='more_city cursor_ponter' onClick={() => OnClickSeeMoreAndLess(filterList?.hotelFacilities?.length)}>
                                                                See more Amenities
                                                            </li> : <li className='more_city cursor_ponter' onClick={() => OnClickSeeMoreAndLess(5)}>
                                                                Show less Amenities
                                                            </li>
                                                        :
                                                        ''
                                                }

                                            </Fragment>
                                            : <div className='text-start fs-6'>No Amenities Found</div>}


                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="leftFilter5">
                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#panelsStayOpen-collapseFive"
                                    aria-expanded="false"
                                    aria-controls="panelsStayOpen-collapseFive"
                                >
                                    Price
                                </button>
                            </h2>
                            <div id="panelsStayOpen-collapseFive" className="accordion-collapse collapse show" aria-labelledby="leftFilter5">
                                <div className="accordion-body">
                                    <label htmlFor="customRange1" className="form-label">₹{minMaxPrice?.minPrice} <span> - </span> ₹{filterValue?.PriceFilter}</label>
                                    <input
                                        type="range"
                                        className="form-range"
                                        id="customRange1"
                                        step={100}
                                        min={minMaxPrice?.minPrice}
                                        max={minMaxPrice?.maxPrice}
                                        value={filterValue?.PriceFilter}
                                        // onChange={handlePriceOnchange}
                                        onChange={(e) => handleOnChange('PriceFilter', e.target.value, null, "range")}
                                    // onPointerUp={handlePriceChangeComplete}
                                    // onMouseUp={handlePriceChangeComplete}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HotelFilter